import { useCallback } from 'react';

export const useRescanFraudHandler = (
  rescanFraud: (attachmentId: string) => Promise<void>,
  attachmentId?: string,
) => {
  const handler = useCallback(() => {
    if (attachmentId) {
      rescanFraud(attachmentId);
    }
  }, [rescanFraud, attachmentId]);

  return handler;
};
